import { COUNTRIES } from './countries';

export const environment = {
  baseApiUrl: 'https://dev-api.zuntime.zunzunsolutions.com',

  /** Local countries catalog for country autocomplete (no external API). */
  countries: COUNTRIES,

  DISTRIBUTION_MIDDLE_MAP: {
    'DA-PWR': '1930',
    'Cyan Core Services': '1930',
    'BI-INTHODA': '1930',
    'BI-INTCYAN': '1930',
    'CA-SUPP': '6806',
    'CA-MISCENH': '1930',
    'CN-SET': '1930',
    'FIL-MISCENH': '1930',
    'CA-CASHAVAIL': '1930',
    'CN-MISCENH': '1930',
    'CN-ZDSK': '1930',
    'CA-BGTNAT': '1930',
    'BI-EXEC': '1930',
    'BI-FFI': '1930',
    'BI-MISCP': '1930',
    'BI-RSS': '1930',
    'BI-SUPP': '6806',
    'CN-HODA': '1930',
    'CN-CICD': '6806',
    CYAN: '1930',
    DATA: '1930',
    'BI-BTEN': '1930',
    'CM-MISCENH': '1930',
    'CN-SUPP': '6806',
    'CA-CICD': '6806',
    'BI-HODA-HODA': '1930',
    'BI-CYAN-CYAN': '1930',
    'PL-MISC': '1930',
    BT: '1930',
  },

  DISTRIBUTION_ENDING_MAP: {
    'DA-PWR': '0004',
    'Cyan Core Services': '0001',
    'BI-INTHODA': '0004',
    'BI-INTCYAN': '0004',
    'CA-SUPP': '0006',
    'CA-MISCENH': '0006',
    'CN-SET': '0006',
    'FIL-MISCENH': '0006',
    'CA-CASHAVAIL': '0006',
    'CN-MISCENH': '0006',
    'CN-ZDSK': '0006',
    'CA-BGTNAT': '0006',
    'BI-EXEC': '0005',
    'BI-FFI': '0006',
    'BI-MISCP': '0006',
    'BI-RSS': '0006',
    'BI-SUPP': '0006',
    'CN-HODA': '0002',
    'CN-CICD': '0006',
    CYAN: '0001',
    DATA: '0004',
    'BI-BTEN': '0006',
    'CM-MISCENH': '0006',
    'CN-SUPP': '0006',
    'CA-CICD': '0006',
    'BI-HODA-HODA': '0004',
    'BI-CYAN-CYAN': '0004',
    'PL-MISC': '0005',
    BT: '0008',
  },

  CONTRACTORS_DESCRIPTION_MAP: {
    'DA-PWR': '0004-0000-Zunzun',
    'Cyan Core Services': '0001-0000-Zunzun',
    'BI-INTHODA': '0004-0000-Zunzun',
    'BI-INTCYAN': '0004-0000-Zunzun',
    'CA-SUPP': '0006-0000-Zunzun',
    'CA-MISCENH': '0006-0000-Zunzun',
    'CN-SET': '0006-0000-Zunzun',
    'FIL-MISCENH': '0006-0000-Zunzun',
    'CA-CASHAVAIL': '0006-0000-Zunzun',
    'CN-MISCENH': '0006-0000-Zunzun',
    'CN-ZDSK': '0006-0000-Zunzun',
    'CA-BGTNAT': '0006-0000-Zunzun',
    'BI-EXEC': '0005-0000-Zunzun',
    'BI-FFI': '0006-0000-Zunzun',
    'BI-MISCP': '0006-0000-Zunzun',
    'BI-RSS': '0006-0000-Zunzun',
    'BI-SUPP': '0006-0000-Zunzun',
    'CN-HODA': '0002-0000-Zunzun',
    'CN-CICD': '0006-0000-Zunzun',
    CYAN: '0001-0000-Zunzun',
    DATA: '0004-0000-Zunzun',
    'BI-BTEN': '0006-0000-Zunzun',
    'CM-MISCENH': '0006-0000-Zunzun',
    'CN-SUPP': '0006-0000-Zunzun',
    'CA-CICD': '0006-0000-Zunzun',
    'BI-HODA-HODA': '0004-0000-Zunzun',
    'BI-CYAN-CYAN': '0004-0000-Zunzun',
    'PL-MISC': '0005-0000-Zunzun',
    BT: '0008-0000-Zunzun',
  },
};
